// Grupos da Visão do Financeiro (PO1-3745, sprint "Visão do Financeiro").
//
// O financeiro não acompanha as 11 situações da fatura: quer saber o que ainda
// está em conferência (Pendente), o que já pode pagar (Liberado) e o que já
// pagou (Pago). Mesma tabela do backend em
// backend_hub/src/app/modules/faturas/financeiroGrupos.js; mudar aqui exige
// mudar lá. Cancelada (3) fica fora de todos os grupos.
//
// Integrada (8, código PAG) entra em "Liberado para pagar": é a fatura conferida
// e enviada ao contas a pagar (ou gravada no ERP), ainda NÃO paga. Nunca
// mostrar Integrada como "Paga".

export const GRUPOS = [
  {
    key: "PENDENTE",
    label: "Pendente",
    descricao: "Em conferência ou com divergência. Ainda não pode ser paga.",
    idSituacoes: [1, 2, 4, 5, 6, 9, 10],
    cor: "var(--everlog-status-warning)",
    // Coluna de data da tabela neste grupo.
    colunaData: { label: "Entrada", campo: "dataEmissaoInterna", formato: "data" },
  },
  {
    key: "LIBERADO",
    label: "Liberado para pagar",
    descricao: "Conferida pela logística e liberada. Integrada = já enviada ao contas a pagar.",
    idSituacoes: [7, 8],
    cor: "var(--everlog-status-info)",
    colunaData: { label: "Liberada em", campo: "dataPagamento", formato: "dataBRT" },
  },
  {
    key: "PAGO",
    label: "Pago",
    descricao: "Pagamento confirmado pelo financeiro.",
    idSituacoes: [11],
    cor: "var(--everlog-status-success)",
    colunaData: { label: "Paga em", campo: "dataPagamentoReal", formato: "dataBRT" },
  },
];

export const GRUPO_PADRAO = "LIBERADO";

// Só a Integrada (8, PAG) pode ser marcada como paga: a Liberada (7) ainda
// precisa ser integrada na Auditoria Fatura (ação PAGAR / Enviar ao financeiro).
export const SITUACAO_MARCAVEL_PAGA = "PAG";

export const grupoPorKey = (key) => GRUPOS.find((g) => g.key === key) || null;

export const grupoDaSituacao = (idSituacao) => {
  const id = Number(idSituacao);
  const g = GRUPOS.find((x) => x.idSituacoes.includes(id));
  return g ? g.key : null;
};

// A fatura pode receber "Marcar como paga" nesta tela?
export const podeMarcarPaga = (fatura) =>
  Boolean(fatura && fatura.situacaoCodigo === SITUACAO_MARCAVEL_PAGA);

// Por que a linha não pode ser marcada (tooltip).
export const motivoNaoMarcavel = (fatura) => {
  if (!fatura) return "";
  if (fatura.situacaoCodigo === SITUACAO_MARCAVEL_PAGA) return "";
  if (fatura.situacaoCodigo === "LIB") {
    return "Liberada, mas ainda não integrada. Integre na Auditoria Fatura antes de marcar como paga.";
  }
  if (fatura.situacaoCodigo === "PGO") return "Já está paga.";
  return "Só faturas Integradas podem ser marcadas como pagas.";
};

// Resumo vazio para a tela abrir com os 3 cards antes da resposta.
export const resumoVazio = () =>
  GRUPOS.reduce((acc, g) => ({ ...acc, [g.key]: { qtd: 0, valor: 0 } }), {});
